import { render, staticRenderFns } from "./editOrderDialog.vue?vue&type=template&id=88f42958&scoped=true"
import script from "./editOrderDialog.vue?vue&type=script&lang=js"
export * from "./editOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./editOrderDialog.vue?vue&type=style&index=0&id=88f42958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f42958",
  null
  
)

export default component.exports